// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2-hg1";
export var footerBkg = "footer-module--footerBkg--1gR01";
export var footerLogo = "footer-module--footerLogo--DW30W";
export var footerContent = "footer-module--footerContent--1K4zo";